<template>
    <div>
        <modal type="custom" v-if="show">
            <button
                class="btn py-0 px-2 text-3xl float-right border-0 -mr-2"
                @click="close"
            >
                &times;
            </button>
            <div>
                <contentNewLine
                    :value="announcement.announcementContent"
                    v-if="announcement"
                />
            </div>
            <div class="flex flex-row p-3">
                <button
                    class="btn bg-primary font-black ml-auto"
                    @click="close"
                >
                    {{ $t('announcement.acknowledge') }}
                </button>
            </div>
        </modal>
    </div>
</template>

<script>
import modal from '@/components/modal.vue';
import contentNewLine from '@/components/contentNewLine';

function setCookie(name, value, days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export default {
    components: { modal, contentNewLine },
    data: () => ({ show: false }),
    created() {
        if (!this.announcement) {
            return;
        }
        var s = getCookie('announcementClosed');
        if (s !== this.announcement.announcementTs) {
            this.show = true;
        }
    },
    computed: {
        announcement() {
            return this.$store.state.announcement;
        }
    },
    methods: {
        close() {
            if (this.announcement) {
                setCookie(
                    'announcementClosed',
                    this.announcement.announcementTs,
                    180
                );
            }
            this.show = false;
        }
    }
};
</script>
